// /*
// * Broadcast Theme - Custom Recharge Integration
// *
// * Use this file to add custom Javascript to Broadcast. Keeping your custom
// * Javascript in this file will make it easier to update Broadcast. In order
// * to use this file, open layout/theme.liquid and uncomment the custom.js import line near the bottom.
// */

(function () {


    document.addEventListener('DOMContentLoaded', function() {
    // Select all grind dropdowns (handles multiple products on one page too)
    document.querySelectorAll('popout-select').forEach(function(popout) {
        const label = popout.closest('fieldset')?.querySelector('.radio__legend__option-name');
        if (!label) return;

        // Only apply to Grind dropdown
        if (label.textContent.trim() === 'Grind') {
        popout.addEventListener('click', function() {
            // Give time for the Broadcast theme to update selected text
            setTimeout(function() {
            const selectedText = popout.querySelector('[data-popout-toggle-text]').textContent.trim();

            if (selectedText && selectedText !== 'Whole Bean') {
                document.querySelector('.grind-message').style.display = 'block';
            } else {
                document.querySelector('.grind-message').style.display = 'none';
            }
            }, 100);
        });
        }
    });
    });
    // Run once on page load to check the default selection
        document.querySelectorAll('popout-select').forEach(function(popout) {
        const label = popout.closest('fieldset')?.querySelector('.radio__legend__option-name');
        if (label && label.textContent.trim() === 'Grind') {
            const selectedText = popout.querySelector('[data-popout-toggle-text]').textContent.trim();
            const grindMessage = popout.closest('fieldset').parentElement.querySelector('.grind-message');
            if (selectedText && selectedText !== 'Whole Bean') {
            document.querySelector('.grind-message').style.display = 'block';
            } else {
            document.querySelector('.grind-message').style.display = 'none';
            }
        }
        });




  console.log("Initializing Recharge integration with live quantity updates...");

// Ensure theme.formatMoney is defined
if (!window.theme?.formatMoney && Shopify?.formatMoney) {
  window.theme = window.theme || {};
  window.theme.formatMoney = Shopify.formatMoney;
}

document.addEventListener("DOMContentLoaded", function () {
  initRechargeIntegration();
});

// function waitForRechargeAndInit() {
//   let attempts = 0;
//   const maxAttempts = 40;
//   const interval = setInterval(() => {
//     attempts++;
//     const sellingPlanInput = document.querySelector('[name="selling_plan"]');
//     const rechargeWidget = document.querySelector(".rc-container, .recharge-widget, .recharge-selling-plan");

//     if (sellingPlanInput || rechargeWidget) {
//       console.log("Recharge widget detected on attempt", attempts);
//       clearInterval(interval);
//       initRechargeIntegration();
//     } else {
//       console.log("Waiting for Recharge widget, attempt", attempts);
//     }

//     if (attempts >= maxAttempts) {
//       clearInterval(interval);
//       console.warn("Recharge widget never appeared — giving up");
//     }
//   }, 300);
// }

function initRechargeIntegration() {
  //console.log("Setting up Recharge + quantity listeners");

  // MutationObserver for Recharge widget changes
  const widgetContainer = document.querySelector(".rc-container, .recharge-widget, .rc-purchase-option") || document.body;
  if (widgetContainer) {
    const obs = new MutationObserver(() => delayedUpdate());
    obs.observe(widgetContainer, { childList: true, subtree: true });
  }

  // Recharge and variant change events
  document.addEventListener("subscription:option:changed", delayedUpdate);
  document.addEventListener("variant:change", delayedUpdate);

  // Listen for all quantity, variant, and plan changes
  document.body.addEventListener("change", handleInputChange);
  document.body.addEventListener("input", handleInputChange);

  // Add listeners to plus/minus buttons
  document.querySelectorAll('.quantity__plus, .quantity__minus').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(delayedUpdate, 150); // wait for input value to update
    });
  });

  // Initial price setup
  // updatePricesFromRecharge();
}

function handleInputChange(e) {
  const name = e.target.name;
  if (["selling_plan", "id", "quantity", "purchaseOption"].includes(name)) {
    delayedUpdate();
  }
}

function delayedUpdate() {
  clearTimeout(window._rechargePriceTimer);
  window._rechargePriceTimer = setTimeout(updatePricesFromRecharge, 200);
}


function updatePricesFromRecharge() {
  //console.log("updatePricesFromRecharge() called");

  const addBtn = document.querySelector('.main-addbtn-cls');
  const addBtnBar = document.querySelector('[type="button"][name="add"], .addbtn-cart-bar-cls');
  const priceEl = addBtn?.querySelector('.btn__price') || document.querySelector('.product-price, .price');
  //console.log('44',addBtn);
  const priceElBar = addBtnBar?.querySelector('.btn__price') || document.querySelector('.product-price, .price');
  //console.log('55',addBtnBar);
  const mainPriceEl = document.querySelector('.product__price [data-product-price]'); 

  if (!priceEl || !window.theme?.formatMoney) {
    //console.warn("Missing price element or formatter");
    return;
  }

  // Quantity
  const quantityInput = document.querySelector('input[name="quantity"], .quantity__input');
  const quantity = parseInt(quantityInput?.value, 10) || 1;
  // Variant
  const selectedVariantId = document.querySelector('form [name="id"]')?.value;
  let variant = null;

  if (selectedVariantId && window.product && Array.isArray(window.product.variants)) {
    variant = window.product.variants.find(
      v => String(v.id) === String(selectedVariantId)
    );
  }

  //  console.log(variant);

  // if (!variant) {
  //   priceEl.textContent = "Unavailable";
  //   return;
  // }

  // Determine if subscription
  let isSubscription = false;
  const selectedPurchaseOption = document.querySelector('input[name="purchaseOption"]:checked');
  const planInput = document.querySelector('[name="selling_plan"]');


  if (selectedPurchaseOption) {
    isSubscription = selectedPurchaseOption.value === "subscription";
  } else if (planInput) {
    isSubscription = !!planInput.value;
  }

  
  // Calculate price
  let finalPrice = variant.price;

  if (isSubscription) {
    const rechargeWidget = document.querySelector('recharge-subscription-widget');
    if (rechargeWidget?.shadowRoot) {
      const rcPriceEl = rechargeWidget.shadowRoot.querySelector(".rc-price:not(.strike-through)");
      if (rcPriceEl) {
        const priceText = (rcPriceEl.textContent.match(/\$?\d+(?:\.\d{2})?/) || [null])[0];
        if (priceText) {
          const numeric = parseFloat(priceText.replace(/[^0-9.]/g, ""));
          if (!isNaN(numeric)) {
            finalPrice = numeric * 100; // Convert to cents
          }
        }
      }
    }
  }
  
  // Multiply by quantity
  const total = finalPrice * quantity;
  const formatted = window.theme.formatMoney(total, theme.moneyFormat);
  
  // Update UI
  priceEl.textContent = formatted;
  priceElBar.textContent = formatted;
  if (mainPriceEl) mainPriceEl.textContent = window.theme.formatMoney(finalPrice, theme.moneyFormat);
  //console.log(priceEl.textContent);

  //console.log(`Updated price: ${formatted} (Variant: ${selectedVariantId}, Qty: ${quantity}, Sub: ${isSubscription})`);
}

//console.log("Recharge Pricing Logic (Subscription Default) Loaded");

document.addEventListener("DOMContentLoaded", () => {
  window.productJson = JSON.parse(
    document.getElementById("product-json").textContent
  );
  updatePrice();
});

// function initRechargePricing() {

//   // 🔥 Broadcast Theme Variant Change Event
//   document.addEventListener("product:variant-change", (e) => {
//     console.log("Broadcast Variant Changed:", e.detail.variant);
    
//     // Sometimes the hidden input[name="id"] updates after a delay
//     setTimeout(updatePrice, 50);
//   });

//   // Regular change handlers (quantity, selling plan, one-time/subscription)
//   document.body.addEventListener("change", handleUpdate);
//   document.body.addEventListener("input", handleUpdate);

//   // Quantity buttons
//   document.querySelectorAll(".quantity__plus, .quantity__minus").forEach(btn => {
//     btn.addEventListener("click", () => setTimeout(updatePrice, 120));
//   });

//   // Load subscription price by default
//   updatePrice();
// }


// function handleUpdate(e) {
//   const name = e.target.name;
//   if (["id", "selling_plan", "quantity", "purchaseOption"].includes(name)) {
//     updatePrice();
//   }
// }

function updatePrice() {
  console.log("=== PRICE UPDATE TRIGGERED ===");

  const product = window.productJson;
  if (!product) return console.warn("Product JSON missing");

  // Quantity
  const quantity = parseInt(document.querySelector('input[name="quantity"]')?.value || 1);

  // Variant
  const variantId = document.querySelector('[name="id"]')?.value;
  const variant = product.variants.find(v => String(v.id) === String(variantId));

  if (!variant) {
    console.warn("Variant not found");
    return;
  }

  // Selected Purchase Option  
  const selectedOption = document.querySelector('input[name="purchaseOption"]:checked');

  // If nothing selected → DEFAULT subscription
  let isSubscription = true; 
  if (selectedOption) {
    isSubscription = selectedOption.value === "subscription";
  }

  let finalPrice = variant.price || 0; // default price (cents)

  // ---- SUBSCRIPTION PRICE LOGIC ----
  if (isSubscription) {
    console.log("Subscription: TRUE (default)");
    const sellingPlanId = document.querySelector('[name="selling_plan"]')?.value;

    let allocation = null;

    // If a specific selling plan is selected, use it
    if (sellingPlanId) {
      allocation = variant.selling_plan_allocations?.find(
        sp => String(sp.selling_plan_id) === String(sellingPlanId)
      );
    }

    // If still not found → use the FIRST subscription plan
    if (!allocation && variant.selling_plan_allocations?.length) {
      allocation = variant.selling_plan_allocations[0];
    }

    // Apply subscription price if available
    if (allocation?.price_adjustments?.length) {
      finalPrice = allocation.price_adjustments[0].price;
    }
  }

  // Total price
  const total = finalPrice * quantity;

  // Money formatting helper
  const fmt = (amount) => {
    return window.theme && typeof theme.formatMoney === "function"
      ? theme.formatMoney(amount, theme.moneyFormat)
      : (amount / 100).toFixed(2);
  };

  const formatted = fmt(total);

  // UI elements
  const addBtnPrice = document.querySelector(".main-addbtn-cls .btn__price");
  const barBtnPrice = document.querySelector(".addbtn-cart-bar-cls .btn__price");
  const mainPriceEl = document.querySelector('.product__price [data-product-price]');

  if (addBtnPrice) addBtnPrice.textContent = formatted;
  if (barBtnPrice) barBtnPrice.textContent = formatted;
  if (mainPriceEl) mainPriceEl.textContent = fmt(finalPrice);

  console.log("Updated Price:", {
    variantId,
    quantity,
    isSubscription,
    finalPrice: fmt(finalPrice),
    total: formatted
  });
}
})();

(function () {

  const GIFT_PROPS = {
    first : '__rc_gift_recipient_first_name',
    last  : '__rc_gift_recipient_last_name',
    email : '__rc_gift_recipient_email',
    from  : '__rc_gift_sender_name',
    date  : '__rc_gift_notification_scheduled_at',
  };

  let cachedCart = null;

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildGiftBlock(item) {
    const p     = item.properties || {};
    const email = p[GIFT_PROPS.email];
    if (!email) return null;

    const firstName = p[GIFT_PROPS.first] || '';
    const lastName  = p[GIFT_PROPS.last]  || '';
    const rows      = [];

    if (firstName || lastName)
      rows.push(['Recipient', [firstName, lastName].filter(Boolean).join(' ')]);

    rows.push(['Recipient email', email]);

    if (p[GIFT_PROPS.from])  rows.push(['From',      p[GIFT_PROPS.from]]);
    if (p[GIFT_PROPS.date])  rows.push(['Send date', p[GIFT_PROPS.date]]);

    const lis = rows.map(([label, value]) =>
      `<li class="rc-gift__row">
         <span class="rc-gift__label">${escapeHtml(label)}:</span>
         <span class="rc-gift__value">${escapeHtml(value)}</span>
       </li>`
    ).join('');

    return `
      <div class="rc-gift-details">
        <p class="rc-gift-details__heading">Recipient Details</p>
        <ul class="rc-gift-details__list">${lis}</ul>
      </div>`;
  }

  // Try common attributes SlideCart/Shopify themes use to identify a line item
  function getNodeKey(node) {
    return (
      node.dataset.key ||
      node.dataset.lineItemKey ||
      node.getAttribute('data-key') ||
      node.getAttribute('data-line-item-key') ||
      null
    );
  }

  function findItemForNode(node, cartItems, fallbackIndex) {
    const key = getNodeKey(node);
    if (key) {
      const match = cartItems.find(i => i.key === key);
      if (match) return match;
    }
    // Only fall back to index match if no key attribute was found at all.
    // If a key existed but didn't match, do NOT guess — return null.
    if (!key) return cartItems[fallbackIndex] || null;
    return null;
  }

  function injectGiftDetails(cart) {
    if (!cart) return;

    const itemNodes = document.querySelectorAll('#slidecarthq .item');
    const cartItems = cart.items || [];

    itemNodes.forEach((node, index) => {
      const item = findItemForNode(node, cartItems, index);

      // Always remove any existing gift block first — prevents stacking
      const existing = node.querySelector(':scope > .rc-gift-details, .title + .rc-gift-details');
      if (existing) existing.remove();

      if (!item) return;

      const html = buildGiftBlock(item);
      if (!html) return; // not a gift item — leave the node alone

      const anchor = node.querySelector('.title');
      if (anchor) {
        anchor.insertAdjacentHTML('afterend', html);
      } else {
        node.insertAdjacentHTML('beforeend', html);
      }
    });
  }

  function handleCartEvent(cart) {
    if (cart) cachedCart = cart;
    injectGiftDetails(cachedCart);
  }

  let debounceTimer = null;
  function debouncedInject() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => injectGiftDetails(cachedCart), 80);
  }

  function wrapHooks() {
    const _prevLoaded = window.SLIDECART_LOADED;
    window.SLIDECART_LOADED = function (cart) {
      if (typeof _prevLoaded === 'function') _prevLoaded(cart);
      handleCartEvent(cart);
    };

    const _prevUpdated = window.SLIDECART_UPDATED;
    window.SLIDECART_UPDATED = function (cart) {
      if (typeof _prevUpdated === 'function') _prevUpdated(cart);
      handleCartEvent(cart);
    };
  }

  function startObserver() {
    const root = document.getElementById('slidecarthq');
    if (!root) return;

    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some(m =>
        [...m.addedNodes].some(n =>
          n.nodeType === 1 &&
          (n.matches?.('.item') || n.querySelector?.('.item'))
        )
      );
      if (relevant && cachedCart) debouncedInject();
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    wrapHooks();

    if (document.getElementById('slidecarthq')) {
      startObserver();
    } else {
      const bodyObserver = new MutationObserver((_, obs) => {
        if (document.getElementById('slidecarthq')) {
          obs.disconnect();
          startObserver();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

